import { Helmet } from "react-helmet-async"
import { TripHotelsVoucher } from "../../../../../Trips"
import { useTripDetailsOutletContext } from "../_trip-details-context"

export default function TripHotelsVoucherPage() {
	const { trip, hasChangesBetweenQuoteAndBookings } =
		useTripDetailsOutletContext()
	return (
		<>
			<Helmet>
				<title>Trip Hotel Voucher Docs</title>
			</Helmet>
			<TripHotelsVoucher
				trip={trip}
				disabledSharing={hasChangesBetweenQuoteAndBookings}
			/>
		</>
	)
}
